<script lang="ts">
  interface Props {
    library_video: LibraryVideoType
    onViewVideo: (library_video: LibraryVideoType) => void
  }
  let props = $props()

  let { library_video, onViewVideo }: Props = props

  import play_icon from "@images/university/play-icon.png"
</script>

<button
  type="button"
  onclick={() => onViewVideo(library_video)}
  class="swiper-slide relative w-full shadow-lg bg-gray-800 overflow-hidden h-48"
  aria-label={`View video: ${library_video.title}`}
>
  <img
    src={play_icon}
    class="absolute inset-0 opacity-50 hover:opacity-100 z-30"
    alt="Play"
  />
  <div class="absolute inset-0 bg-gray-700 opacity-70 z-10"></div>
  <img
    src={library_video.thumbnail_url}
    class="object-fill w-full h-48"
    alt={library_video.title}
  />
</button>

<style>
  .swiper-slide {
    -webkit-transition: 250ms all;
    transition: 250ms all;
  }

  .swiper-slide:hover {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    z-index: 1;
  }

  .swiper-slide:first-child:hover {
    margin: 0 40px;
  }

  .swiper-slide:last-child:hover {
    margin: 0 -40px;
  }
</style>
